/**
 * React Router configuration
 * Defines all routes for the @Nicefoxnet application
 */

import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { EpisodeList } from './components/Episode/EpisodeList';
import { Editor } from './components/Editor/Editor';
import { PresentationMode } from './components/Presentation/PresentationMode';
import { LoginPage } from './components/Auth/LoginPage';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/episodes" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/episodes',
    element: <EpisodeList />,
  },
  {
    path: '/episodes/new',
    element: <EpisodeList createModalOpen={true} />,
  },
  // Editor routes with view state in URL
  {
    path: '/episodes/:id',
    element: <Editor />,
  },
  {
    path: '/episodes/:id/intro',
    element: <Editor />,
  },
  {
    path: '/episodes/:id/section/:sectionIndex',
    element: <Editor />,
  },
  {
    path: '/episodes/:id/outro',
    element: <Editor />,
  },
  {
    path: '/episodes/:id/present',
    element: <PresentationMode />,
  },
  {
    path: '*',
    element: <Navigate to="/episodes" replace />,
  },
];

export const router = createBrowserRouter(routes);
